import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";
import AppointmentsWidget from "../components/channels/widgets/AppointmentsWidget";
import { WidgetContext } from "../components/channels/widgets/WidgetContainer";
import WidgetFrame from "../components/shared/widgets/WidgetFrame";

// Connects to data-controller="article-appointment"
// The "Terminhinweis" of a channel blog article (tixxt/core#373): the same
// card the appointments widget renders, in the same frame, mounted into the
// server-rendered article page. The widget context is handed in because the
// card asks it for the column count to decide on the image, and outside a
// widget grid there is none; one column is what the article shows.
export default class extends Controller {
  static values = { appointment: Object, title: String };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <QueryClientProvider>
        <WidgetContext.Provider
          value={{ w: 1, vertical: false, containerRef: null }}
        >
          {/* the channel classes give the frame its theme colors, the title
              bar its height and the content its natural height */}
          <WidgetFrame
            title={this.titleValue}
            titleClassName="widget__title"
            className="widget__container widget__container--natural-height-always"
            contentClassName="widget__content"
          >
            <AppointmentsWidget appointment={this.appointmentValue} />
          </WidgetFrame>
        </WidgetContext.Provider>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    this.root?.unmount();
  }
}
